import React from 'react'
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
    buttonStandard: {
        fontSize: '1rem',
        color: '#ffffff',
        borderRadius: '4px',
        '&.Mui-disabled': {
            backgroundColor: "#a7a8a8",
        },
        '&:hover': {
            backgroundColor: "#706D85",
        },
        backgroundColor: "#2E2757",
        //fontFamily: 'MyriadPro-Bold',
    },
    divStandard: {
        padding: "20px",
        // border: '2px solid #BEBCC0',
        backgroundColor: theme.palette.type === 'dark' ? '#4a4a4a' : '#fafafa',
        borderRadius: "16px",
        // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
    }
}));

const validate = values => {
    const error  = {}
    if (!values.reference) {
        error.cellphone = "El número de celular es obligatorio"
    }
    /* if (!values.amount) {
        error.amount = "El monto a recargar es obligatorio"
    } */
    if (/^[0-9]{10}$/.test(values.reference) === false) {
        error.cellphone = "El número de celular debe contener 10 caracteres numéricos."
    }
    
    return error 
}

const required = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if (AgreementForm.length > 0) {

        if (!value) {
            return `${AgreementForm[0].label} es requerido(a).`
        } else {
            return undefined
        }
    } else {
        return undefined
    }
}

const maxLengthReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if (AgreementForm.length > 0) {

        if (value.length > parseInt(AgreementForm[0].maxLength)) {
            return `Debe tener ${AgreementForm[0].maxLength} carácteres o menos.`
        } else {
            return undefined
        }
    } else {
        return undefined
    }
}

const validateReference = (value, allValues, props) => {

    const { AgreementForm } = props.agreementsSelected

    if (AgreementForm.length > 0) {

        let exp = new RegExp(AgreementForm[0].pattern);

        if (exp.test(value) === false) {
            return AgreementForm[0].messageValidationPattern
        } else {
            return undefined
        }
    } else {
        return undefined
    }

}

const ServiceSwitchForm = props => {

    const classes = useStyles();

    const {
        handleSubmit,
        agreementsSelected,
        setAgreementsSelected,
        agreements,
        onCancelAction,
        titleSelectAgreement,
        titleLabelReference,
        invalid
    } = props
    // .log('props', props)

    return (  
        <div className={classes.divStandard}>
            <form className={classes.form} onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Autocomplete
                            id="select_agrement_combo_box"
                            value={agreementsSelected}
                            options={agreements}
                            disableClearable
                            getOptionLabel={(option) => (option.name) ? option.name : ""}
                            style={{ width: '100%' }}
                            onChange={(e, nv) => {
                                setAgreementsSelected(nv)
                            }}
                            renderInput={(params) => <TextField {...params} label={titleSelectAgreement} variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={12}>

                        <Field
                            name="reference"
                            id="reference"
                            validate={[required, validateReference, maxLengthReference]}
                            autoFocus={true}
                            component={RenderTextFieldRedux}
                            label={titleLabelReference}
                            fullWidth
                        />

                    </Grid>

                    <Grid item xs={6} md={6} lg={6} xl={6} container justifyContent='center'>
                        <Button variant="contained" type="submit" id={"consult_agrement_btn"}
                            color='primary'
                            disabled={invalid}
                        >
                            Consultar
                        </Button>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={6} container justifyContent='center'>
                        <Button variant="outlined" id={"cancel_agrement_btn"}
                            color='primary'
                            onClick={() => onCancelAction()}>
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}

const ServiceSwitchFormReduxForm = reduxForm(
    {
        form: 'ServiceSwitchForm',
        validate
    }
)(ServiceSwitchForm)
export default ServiceSwitchFormReduxForm
